module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/124.6a2164c6.png";